import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { SettingsService } from "../../services/settings.service";
import { ISettings } from "../../models/Settings";

export const useGetSettingsQuery = () => {
  return useQuery<ISettings, Error>({
    queryKey: [QUERY_CONSTANTS.GET_SETTINGS],
    queryFn: () => SettingsService.getSettings().then((res) => res.data),
  });
};
